import CornerLogo from "./CornerLogo";

export default CornerLogo;
